export default __webpack_public_path__ + "static/new-roma-scheda-tecnica-f0b356e376f2034ee4dd59e217135a1d.pdf";